import {
  LIST_VARIAVEIS_INIT,
  LIST_VARIAVEIS_SUCCESS,
  CREATE_VARIAVEL_INIT,
  CREATE_VARIAVEL_SUCCESS,
  UPDATE_VARIAVEL_INIT,
  UPDATE_VARIAVEL_SUCCESS,
  DELETE_VARIAVEL_INIT,
  DELETE_VARIAVEL_SUCCESS,
  VARIAVEIS_ERROR_MSG,
  CLEAR_FLAGS_VARIAVEIS
} from '../actionTypes';

export const listVariaveisInit = () => ({
  type: LIST_VARIAVEIS_INIT
});

export const listVariaveisSuccess = (data: any) => ({
  type: LIST_VARIAVEIS_SUCCESS,
  payload: data
});

export const createVariavelInit = (data: any) => ({
  type: CREATE_VARIAVEL_INIT,
  payload: data
});

export const createVariavelSuccess = (data: any) => ({
  type: CREATE_VARIAVEL_SUCCESS,
  payload: data
});

export const updateVariavelInit = (data: any) => ({
  type: UPDATE_VARIAVEL_INIT,
  payload: data
});

export const updateVariavelSuccess = (data: any) => ({
  type: UPDATE_VARIAVEL_SUCCESS,
  payload: data
});

export const deleteVariavelInit = (data: any) => ({
  type: DELETE_VARIAVEL_INIT,
  payload: data
});

export const deleteVariavelSuccess = (data: any) => ({
  type: DELETE_VARIAVEL_SUCCESS,
  payload: data
});

export const errorVariaveisMsg = (data: any) => ({
  type: VARIAVEIS_ERROR_MSG,
  payload: data
});

export const clearFlagsVariaveis = () => ({
  type: CLEAR_FLAGS_VARIAVEIS
});
